import React from "react";
import { Link, NavLink } from "react-router-dom";

function Navbar({ isDarkMode, onToggleTheme }) {
  return (
    <nav className="app-navbar">
      <div className="nav-inner">
        <Link to="/" className="brand-pill">
          <span className="brand-icon">⌘</span>
          <span className="brand-text">
            <strong className="brand-script brand-nav">GITHUNT</strong>
            <small>GitHub profile explorer</small>
          </span>
        </Link>
        <div className="nav-links">
          <NavLink exact to="/" className="nav-link" activeClassName="active">
            Home
          </NavLink>
          <NavLink to="/about" className="nav-link" activeClassName="active">
            About
          </NavLink>
          <button
            type="button"
            className="theme-toggle"
            onClick={onToggleTheme}
            aria-label="Toggle color theme"
          >
            {isDarkMode ? "☀️" : "🌙"}
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
